<template>
  <div class="text-section">
    <div class="text-section__wrapper">
      <component
        v-for="component of components"
        :key="component.id"
        :is="textComponents[component.component]"
        v-bind="component.content"
      />
    </div>
  </div>
</template>

<script setup>
import TextQuote from "../atoms/TextQuote.vue";

const textComponents = {
  TextQuote,
};
defineProps({
  components: {
    type: Array,
    default: () => [],
  },
});
</script>

<style lang="scss" scoped>
.text-section {
  --width: 42.875rem;
  padding-left: var(--page-padding-h);
  padding-right: calc(100% - var(--width) - var(--page-padding-h));

  width: 100%;

  border-top: var(--section-border);

  &__wrapper {
    @include lineRight;
    @include lineLeft;

    padding-bottom: 3rem;
    padding-top: 3rem;
  }

  .desktop & {
    &__wrapper {
      &::after {
        
      }
      &::after,
      &::before {
        display: none;
      }
    }
  }

  .tablet &,
  .mobile & {
    width: calc(100%);
    padding-top: 0;
    padding-bottom: 0;
    padding-right: var(--page-padding-h);
    margin-bottom: 0;
    &__wrapper {
      padding-bottom: 0
    }
  }
}
</style>
